import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { playCorrectPing } from '../games/ping';

const COLOURS = ['#e76f51', '#2a9d8f', '#e9b949', '#4a78c2', '#8e6bbf', '#e07a9b'];
const PIECES = 26;
const LENGTH = 2600;

export default function Celebration({ text, motion }: { text: string; motion: boolean }) {
  const [shown, setShown] = useState(true);
  const banner = useRef<HTMLDivElement | null>(null);
  const bits = useRef<(HTMLSpanElement | null)[]>([]);

  useEffect(() => {
    playCorrectPing();
    const id = window.setTimeout(() => setShown(false), LENGTH);
    return () => window.clearTimeout(id);
  }, []);

  useLayoutEffect(() => {
    if (!motion) return;
    banner.current?.animate(
      [{ transform: 'translate(-50%, -50%) scale(0.6)', opacity: 0 }, { transform: 'translate(-50%, -50%) scale(1.08)', opacity: 1, offset: 0.6 }, { transform: 'translate(-50%, -50%) scale(1)', opacity: 1 }],
      { duration: 420, easing: 'ease-out' },
    );
    bits.current.forEach((el, i) => {
      if (!el) return;
      const x = (Math.random() - 0.5) * 60;
      const turn = (Math.random() - 0.5) * 540;
      el.animate(
        [{ transform: 'translate(0, -10%) rotate(0deg)', opacity: 0 }, { opacity: 1, offset: 0.1 }, { transform: `translate(${x}px, 420px) rotate(${turn}deg)`, opacity: 0 }],
        { duration: 1500 + Math.random() * 600, delay: (i % 8) * 60, easing: 'cubic-bezier(.2,.6,.4,1)', fill: 'both' },
      );
    });
  }, [motion]);

  if (!shown) return null;
  return (
    <div className="lz-celebrate" aria-hidden="true">
      {motion && Array.from({ length: PIECES }, (_, i) => (
        <span
          key={i}
          ref={(el) => { bits.current[i] = el; }}
          className="lz-bit"
          style={{ left: `${(i * 37) % 100}%`, background: COLOURS[i % COLOURS.length], borderRadius: i % 3 === 0 ? '50%' : '2px' }}
        />
      ))}
      <div ref={banner} className="lz-banner">{text}</div>
    </div>
  );
}
